import { Button, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useSelector } from "src/stateManagement/redux";
import DoneIcon from '@mui/icons-material/Done';
import WarningIcon from '@mui/icons-material/Warning';
import LinearScaleIcon from '@mui/icons-material/LinearScale';
import { ModalFixLiquidLevel } from "./modalFixLiquidLevel";

export const FluidLevels = () => {

    const { fluidLevels } = useSelector((state) => state.location);

    const [openModal, setopenModal] = useState(false);

    const [activeFluidLevel, setActiveFluidLevel] = useState<any>(undefined)

    const onClickOpenLiquidLevel = (params:any) => {
        setActiveFluidLevel(params.row)
        setopenModal(true)
    }

    const handleOpenCloseModal = () => {
        setopenModal(!openModal)
        setActiveFluidLevel(undefined)
    }


    const paginationModel = { page: 0, pageSize: 10 };
    const columns: GridColDef[] = [
        {
            field: 'status', type: 'actions', flex: 0.1, renderCell: (params) => {
                if (params.value === 'completed') {
                    return (
                        <IconButton size="small" color="success">
                            <DoneIcon />
                        </IconButton>
                    )
                } else if (params.value === 'analyzing') {
                    return (
                        <IconButton size="small" color="warning">
                            <WarningIcon />
                        </IconButton>
                    )
                } else {
                    return ""
                }
            }
        },
        { field: "executedDate", headerName: "fecha", flex: 1 },
        { field: "responsable", headerName: "Responsable", flex: 1 },
        { field: "typeOfActivity", headerName: "Tipo de Actividad", flex: 1 },
        { field: "comments", headerName: "Comentario", flex: 1 },
        { field: "liquidLevel", headerName: "Nivel de Fluido", flex: 1 },
        { field: "pip", headerName: "PIP", flex: 1 },
        { field: "pwf", headerName: "Pwf", flex: 1 },
        { field: "pumpSumergence", headerName: "Sumergencia", flex: 1 },
        {
            field: 'actions',
            type: 'actions',
            width: 50,
            renderCell: (params) => (
                <Grid>
                    <IconButton size="small" style={{ transform: "rotate(90deg)" }} onClick={() => onClickOpenLiquidLevel(params)}>
                        <LinearScaleIcon />
                    </IconButton>
                </Grid>
            ),
        }
    ];
    return (
        <Grid container spacing={0}>
            {activeFluidLevel&&<ModalFixLiquidLevel open={openModal} liquidLevel={activeFluidLevel} onClose={handleOpenCloseModal} />}
            <Grid size={12}>
                <DataGrid
                    rows={fluidLevels}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[10, 20, 50, 100]}
                    checkboxSelection={false}
                    sx={{
                        border: 0,
                        mt: 2,
                        "& .MuiDataGrid-columnHeader": {
                            backgroundColor: "#316EBC",
                            color: "#fff",
                            fontWeight: "bold",
                        },
                    }}
                    getRowId={(row) => row.fieldActivityId}
                />
            </Grid>
        </Grid>
    );
};
